import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useCallback } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Box, MotionBox } from '../Box';
import { useBanner } from './BannerContext';
import { BannerItem } from './BannerItem';
var bannerVariant = {
  show: {
    height: 'auto'
  },
  hide: {
    height: 0
  }
};
var bannerTransition = {
  type: 'tween',
  duration: 0.3
};

var AnimateBanner = function AnimateBanner(_ref) {
  var banner = _ref.banner;

  var _useBanner = useBanner(),
      removeBanner = _useBanner.removeBanner;

  var handleDismiss = useCallback(function () {
    removeBanner(banner.id);
  }, [removeBanner, banner.id]);
  return /*#__PURE__*/React.createElement(MotionBox, {
    layout: true,
    overflow: "hidden",
    initial: "hide",
    animate: "show",
    exit: "hide",
    variants: bannerVariant,
    transition: bannerTransition
  }, /*#__PURE__*/React.createElement(BannerItem, _extends({}, banner, {
    onDismiss: handleDismiss
  })));
};

export var BannerList = function BannerList() {
  var _useBanner2 = useBanner(),
      banners = _useBanner2.banners;

  return /*#__PURE__*/React.createElement(Box, {
    "data-test": "banner-list",
    position: "relative"
  }, /*#__PURE__*/React.createElement(AnimatePresence, null, banners.map(function (banner) {
    return /*#__PURE__*/React.createElement(AnimateBanner, {
      key: banner.id,
      banner: banner
    });
  })));
};